import { c as _c } from "react/compiler-runtime";
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { ReactElement } from 'react';
import { iconContainerCSS, iconOccupyCSS } from './IconBlock.css';
import { TextStyleProps } from '@/uiPrimitives/typography/text';
import { h3TextBlock } from '@/uiComposites/typography/headings';
import { icon as iconStyle } from '@/uiPrimitives/media/icon';
export const IconBlock = t0 => {
  const $ = _c(9);
  const {
    children,
    icon,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classes(className, shelf({}));
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon) {
    t2 = icon != null && <div className={classes(iconOccupyCSS, occupy({
      inlineSize: {
        all: indentSize,
        min1120px: "0px"
      },
      justifyItems: "end"
    }))}><div className={classes(iconContainerCSS)}>{icon}</div></div>;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <i className={classes(occupy({
      inlineSize: indentSize,
      blockSize: "auto"
    }), box({
      borderInlineStartStyle: "solid",
      borderWidth: "3px",
      borderColor: "positiveBlue"
    }))} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t2) {
    t4 = <div className={t1}>{t2}{t3}{children}</div>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const iconBlockIcon = (icon: string) => classes(iconStyle({
  icon,
  fill: 'positiveBlue',
  blockSize: '4 | betweenListItems'
}));
export const iconBlockHeading = (textStyleProps: TextStyleProps) => classes(h3TextBlock({
  color: 'positiveBlue',
  ...textStyleProps
}));